<div class="auth-page">

<div class="background-slideshow">
  <div
    *ngFor="let image of images; let i = index"
    class="background-slide"
    [style.background-image]="'url(' + image + ')'"
    [class.active]="i === activeIndex">
  </div>
</div>

<div class="auth-container">
  <div class="auth-left">

    <div class="auth-header">
      <h2>Reset Password</h2>
      <p>Enter your email to receive reset instructions</p>
    </div>

    <!-- ❌ ERRORS -->
    <div *ngIf="errors?.length && !submitted" class="form-group">
      <div class="nb-alert nb-alert-danger">
        <ul>
          <li *ngFor="let error of errors">{{ error }}</li>
        </ul>
      </div>
    </div>

    <!-- ✅ SUCCESS -->
    <div *ngIf="messages?.length && !submitted" class="form-group">
      <div class="nb-alert nb-alert-success">
        <ul>
          <li *ngFor="let msg of messages">{{ msg }}</li>
        </ul>
      </div>
    </div>

    <form
      class="auth-form"
      (ngSubmit)="onForgotPass()"
      #forgotPasswordForm="ngForm">

      <div class="form-group">
        <label class="form-label" for="email">Email Address</label>

        <input
          type="email"
          class="form-input"
          id="email"
          name="email"
          [(ngModel)]="user.email"
          required
          email
          placeholder="Enter your registered email" />
      </div>

      <button
        type="submit"
        class="btn"
        [disabled]="submitted || !forgotPasswordForm.valid">

        <span *ngIf="!submitted && !isLoading">
          Send Reset Link
        </span>

        <span *ngIf="submitted || isLoading">
          Sending...
        </span>
      </button>

      <div class="auth-footer">
        Remember your password?
        <a (click)="onLogin()" class="login-link">Back to login</a>
      </div>
    </form>
  </div>

<div class="auth-right">
  <div class="auth-right-inner">

    <!-- Logo -->
    <div class="logo">
      <img src="assets/images/logoDS.png" alt="Portus ERP">
    </div>

    <!-- Corporate Headline -->
    <!-- <div class="auth-message">

      <p class="tagline">
        Enterprise Platform for Freight & Logistics Operations
      </p>
    </div> -->

    <!-- Value points -->
    <!-- <ul class="auth-points">
      <li>Unified Freight, Accounts & Operations</li>
      <li>Role-based Access & Approval Flow</li>
      <li>Real-time Reporting & Job P&L</li>
      <li>Secure Cloud Infrastructure</li>
    </ul> -->

    <!-- Footer note -->
    <div class="auth-footer-note">
      © 2025 Portus · All rights reserved
    </div>




  </div>
</div>
  <!-- <button class="theme-toggle" (click)="toggleTheme()">
    <i [class]="isDark ? 'fas fa-sun' : 'fas fa-moon'"></i>
  </button> -->
</div>
</div>
